import {lazyRegister} from "@/Core";

interface ICompileTemplateAttributes extends angular.IAttributes {
    compileTemplate: string;
    compileTemplateProps?: string;
}

export class CompileTemplateDirective implements ng.IDirective {
    restrict = 'A';
    static $inject = ['$compile'];

    constructor(private $compile: ng.ICompileService) {
    }

    public link = (
        scope: ng.IScope,
        element: ng.IAugmentedJQuery,
        attrs: ICompileTemplateAttributes
    ): void => {

        scope.$watch(attrs.compileTemplate, (htmlTemplate: string | undefined) => {
            if (htmlTemplate) {
                // Kiểm tra và eval thuộc tính props nếu có
                if (attrs.compileTemplateProps) {
                    scope['$item'] = scope.$eval(attrs.compileTemplateProps);
                }

                // Chống bị AngularJS compile sớm: Thay thế [[ ]] thành {{ }}
                const processedTemplate = htmlTemplate.replace(/\[\[/g, '{{').replace(/\]\]/g, '}}');

                element.empty().html(processedTemplate);
                this.$compile(element.contents())(scope);
            } else {
                element.empty();
            }
        });
    };
}

lazyRegister.directive('compileTemplate', CompileTemplateDirective);